// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://wgxeppssqianmlkjgoyq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "sb_publishable_WDAkMK8bcIMfihctrUFouA_H34Lx0i_";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
